import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "ebooks",
  class: "products-section"
}
const _hoisted_2 = { class: "carousel-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = { class: "card-image" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "card-info" }
const _hoisted_7 = { class: "product-title" }
const _hoisted_8 = { class: "product-price" }

import { ref, onMounted } from 'vue';

interface Book {
  id: string;
  title: string;
  price: number;
  image: { url: string };
  link: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EbooksCarousel',
  setup(__props) {

const endpoint = process.env.VUE_APP_HYGRAPH_URL;
const isAtStart = ref(true); // Controla se o botão 'prev' aparece
const isAtEnd = ref(false);   // Controla se o botão 'next' aparece
// Definição do tipo para TypeScript
const books = ref<Book[]>([]);
const loading = ref(true);
const carouselRef = ref<HTMLElement | null>(null);


  // Função para garantir que as capas dos livros tenham o mesmo tamanho e não estorem
const optimizeThumb = (url: string) => {
  if (!url) return 'https://via.placeholder.com/300x400?text=Sem+Capa'; // Fallback
  return url.replace('https://media.graphassets.com/', 'https://media.graphassets.com/resize=width:400,height:550,fit:crop/');
};

// Função para buscar dados do Hygraph
  const fetchBooks = async () => {

    const query = `
      query GetCursos {
        courses {
          id
          title
          price
          image {
            url
          }
          link
        }
      }
    `;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
      });
      const { data } = await response.json();
      
      if (data && data.courses) {
        books.value = data.courses.map((book: any) => ({
          ...book,
          image: { url: optimizeThumb(book.image?.url) },
          link: book.link
        }));

      }
    } catch (error) {
      console.error("Erro ao carregar dados do Hygraph:", error);
    } finally {
      loading.value = false;
    }
  };

  const checkScrollLimits = () => {
    if (carouselRef.value) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.value;
      
      isAtStart.value = scrollLeft <= 0;
      // O '+1' ajuda a evitar erros de arredondamento em alguns navegadores
      isAtEnd.value = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  };

  const scroll = (direction: 'left' | 'right') => {
    if (carouselRef.value) {
      // Definimos o pulo baseado na largura de um card (280px + 20px de gap)
      const scrollAmount = 300; 
      
      carouselRef.value.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });

      // Aguarda a animação terminar para checar os novos limites
      setTimeout(checkScrollLimits, 400);
    }
  };

  onMounted(() => {
    fetchBooks();
    if (carouselRef.value) {
      carouselRef.value.addEventListener('scroll', checkScrollLimits);
    }
  });


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "section-title" }, "E-BOOKS & CURSOS", -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("button", {
        class: "nav-btn prev",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (scroll('left')))
      }, " ‹ ", 512), [
        [_vShow, !isAtStart.value && books.value.length > 0]
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Carregando catálogo..."))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "product-grid",
            ref_key: "carouselRef",
            ref: carouselRef
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(books.value, (book) => {
              return (_openBlock(), _createElementBlock("div", {
                key: book.id,
                class: "product-card"
              }, [
                _createVNode(_component_router_link, {
                  to: { name: 'LivroDetalhes', params: { id: book.id }},
                  class: "card-link"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: book.image?.url,
                        alt: book.title
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", _hoisted_7, _toDisplayString(book.title), 1),
                      _createElementVNode("p", _hoisted_8, " R$ " + _toDisplayString((book.price || 0).toFixed(2).replace('.', ',')), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ], 512)),
      _withDirectives(_createElementVNode("button", {
        class: "nav-btn next",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (scroll('right')))
      }, " › ", 512), [
        [_vShow, !isAtEnd.value && books.value.length > 0]
      ])
    ])
  ]))
}
}

})